// Locale bez vazby na React – sdílí ho i18n provider i čistě utilitní moduly
// (např. formátování vzdálenosti v lib/geo.ts), aniž by tahaly React do bundlu.

import { parsePath } from "../lib/routes";

/** Podporované jazyky UI. `cs` je zdrojový slovník, ostatní musí mít stejné klíče. */
export type Locale = "cs" | "en";

export const LOCALES: Locale[] = ["cs", "en"];

/** BCP 47 tag pro `Intl.*` API podle locale. */
export const INTL_LOCALE: Record<Locale, string> = {
  cs: "cs-CZ",
  en: "en-GB",
};

export const STORAGE_KEY = "khakham:lang";

function isLocale(value: string | null): value is Locale {
  return value === "cs" || value === "en";
}

/**
 * Zjistí výchozí jazyk: prefix v URL → uložená volba → jazyk prohlížeče
 * (čeština → `cs`) → `en` jako mezinárodní fallback. Bezpečné i mimo prohlížeč
 * (SSR/testy).
 *
 * URL je záměrně první: `/en/...` je adresa, kterou indexuje crawler a která se
 * sdílí odkazem, takže musí dát anglické UI i uživateli s uloženou češtinou.
 * Neprefixované cesty jazyk neurčují, tam rozhoduje uložená volba.
 */
export function detectLocale(pathname = currentPathname()): Locale {
  const fromPath = parsePath(pathname).locale;
  if (fromPath) return fromPath;

  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (isLocale(stored)) return stored;
  } catch {
    /* localStorage nemusí být dostupný (privátní režim apod.) */
  }
  const nav = (typeof navigator !== "undefined" && navigator.language) || "";
  return nav.toLowerCase().startsWith("cs") ? "cs" : "en";
}

function currentPathname(): string {
  return typeof window !== "undefined" ? window.location.pathname : "";
}
